import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { syncJsonStorage } from './storage';

/** Currently selected line ID for "painting mode" in the toolbar */
export const activeLineIdAtom = atom<number | null>(null);

/** Line chip being dragged from the toolbar onto a card paragraph (#1830 mockup).
 *  Native HTML5 drag: dataTransfer payloads are unreadable during dragover, so
 *  the dragged line id travels through this atom instead. */
export const draggedLineIdAtom = atom<number | null>(null);

/** Whether the lines toolbar is visible */
export const linesToolbarVisibleAtom = atomWithStorage<boolean>('storyliner_lines_toolbar_visible', false, syncJsonStorage<boolean>());
